import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/service/seo/seo.service';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {

  mostrarBanner = false;

  constructor(
    private seo: SeoService
  ) { }

  ngOnInit(): void {
    // SEO para Home: "Archivo Histórico | Diario Oficial El Peruano"
    this.seo.setMeta({
      title: 'Archivo Histórico',
      suffix: 'Diario Oficial El Peruano',
      description: 'Explore fotografías históricas, portadas y publicaciones del Archivo del Diario Oficial El Peruano',
      og: true
    });
    this.seo.setCanonicalFromCurrentUrl();
  }

  onEfemeridesVacias(vacias: boolean) {
    this.mostrarBanner = vacias;
  }

}
